/** Key expressions, in one place. Everything on the relay is `adamo/{org}/{name}/...`. */

export const robotTopic = (org: string, robot: string, leaf: string) => `adamo/${org}/${robot}/${leaf}`;
export const statusTopic = (org: string, robot: string) => robotTopic(org, robot, "status");
export const hapticTopic = (org: string, robot: string) => robotTopic(org, robot, "haptic");
/** The box the wrist camera has mapped, every few seconds while it grows (pick_loop.rim_guard). */
export const boxmapTopic = (org: string, robot: string) => robotTopic(org, robot, "boxmap");
export const videoTopic = (org: string, robot: string, track: string) => robotTopic(org, robot, `video/${track}`);

/** Our side. The robot subscribes to these under the operator's name, not the robot's. */
export const handTopic = (org: string, operator: string, side: "left" | "right") =>
  `adamo/${org}/${operator}/control/xr/hand/${side}`;
export const actionTopic = (org: string, operator: string) => `adamo/${org}/${operator}/control/action`;
/** What the headset measured of the video and its own drawing, twice a second (vr/meter.ts). */
export const perfTopic = (org: string, operator: string) => `adamo/${org}/${operator}/control/perf`;

/** The track the headset shows: colour stereo if the robot has it, the flat wrist camera if not. */
export const STEREO_TRACK = "wrist_stereo";
export const WRIST_TRACK = "wrist";
export const SCENE_TRACK = "ego";
